import classNames from 'classnames'
import { isEmpty } from 'lodash'

import MaskedPin from 'components/MaskedPin'

import { displayEmployeeRoles } from 'utils/posAccounts/displayEmployeeRoles'

type TProps = {
  name: string
  phone: string
  email: string
  pinNumber: string
  deactivatedAt: string
  id: number
  roles: string[]
  uuid: string
  onClickItem: (uuid: string) => void
}

const PosAccountsItem = ({ name, pinNumber, deactivatedAt, roles, onClickItem, uuid }: TProps) => {
  const displayEmployeeRole = displayEmployeeRoles(roles)
  const translatedName = isEmpty(name) ? 'unknown' : name
  const displayStatus = isEmpty(deactivatedAt) ? 'Active' : 'Inactive'

  return (
    <div className="item" onClick={() => onClickItem(uuid)} role="button">
      <div className="row">
        <div className="item-info-wrapper">{translatedName}</div>
        <div className="item-info-wrapper">
          <span className="-truncate-text-lg">{displayEmployeeRole}</span>
        </div>
        <div className="item-info-wrapper">
          <span className="-truncate-text-lg">{<MaskedPin pin={pinNumber} />}</span>
        </div>
        <div className="item-info-wrapper">
          <span
            className={classNames('item-info-wrapper__dot', {
              '-success': displayStatus === 'Active',
              '-error': displayStatus === 'Inactive',
            })}
          ></span>
          {displayStatus}
        </div>
      </div>
    </div>
  )
}

export default PosAccountsItem
